export default __webpack_public_path__ + "static/media/align_horizontal_right.a8a4c365.svg";